import { createSlice } from "@reduxjs/toolkit";

const preferredLanguageSlice = createSlice({
  name: "preferredLanguage",
  initialState: "",
  reducers: {
    setPreferredLanguage: (_state, action) => action.payload,
  },
});

export const { setPreferredLanguage } = preferredLanguageSlice.actions;
export default preferredLanguageSlice.reducer;
